import React from 'react';
import styled from 'styled-components';
import { Card } from 'antd';
import { MainCheckHealth } from '@qlibs/react-components';
import { httpRequest } from '../../helpers/api';
import { APP_THEME, CURRENT_APP_THEME } from '../../const/config';

interface Props {
  variant?: 'primary' | 'secondary';
  formPosition?: 'left' | 'right';
  children?: React.ReactNode;
}

const AuthLayout: React.FC<Props> = ({
  children,
  variant = 'primary',
  formPosition = 'right',
}) => {
  return (
    <div>
      {/* {!!process.env.REACT_APP_CHECK_HEALTH_URL && (
        <MainCheckHealth
          url={process.env.REACT_APP_CHECK_HEALTH_URL || '/'}
          axiosInstance={httpRequest as any}
        />
      )} */}
      <Container $currentTheme={APP_THEME}>{children}</Container>
    </div>
  );
};

type ContainerProps = {
  $currentTheme: any;
};

const Container = styled.div<ContainerProps>`
  width: 100%;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 12px;
  overflow-y: auto;
  background-color: var(--bg-dark);
  background-size: cover;
  background-image: ${(props) =>
    props.$currentTheme === CURRENT_APP_THEME.BKI
      ? `url('images/bg-auth-bki.svg')`
      : props.$currentTheme === CURRENT_APP_THEME.NETRA
      ? `url('images/bg-auth-netra.svg')`
      : props.$currentTheme === CURRENT_APP_THEME.ARNANTARA
      ? `url('images/bg-auth-arnantara.svg')`
      : props.$currentTheme === CURRENT_APP_THEME.PINISI
      ? `url('images/bg-auth-pinisi.svg')`
      : `url('images/bg-auth-ramus.svg')`};

  @media (min-width: 576px) {
    padding: 24px;
  }
`;

export const AuthCard = styled(Card)`
  width: min(100%, 400px);
  border-radius: 12px;

  .ant-card-body {
    padding: 20px 16px;
  }

  @media (min-width: 576px) {
    .ant-card-body {
      padding: 24px;
    }
  }
`;

export default AuthLayout;
